import { BoxColumn, BoxItem, BoxSelector } from '@wkda/styleguide';
import cx from 'classnames';
import React, { createElement as _createElement } from 'react';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function BoxSelect(_ref) {
  let {
    options,
    columnClassName,
    renderItems = _ref2 => {
      let {
        options,
        getItemKey,
        columnClassName
      } = _ref2;
      return /*#__PURE__*/_jsx(_Fragment, {
        children: options.map(function boxItemMapper(item) {
          return /*#__PURE__*/_createElement(BoxSelectItem, {
            ...item,
            key: getItemKey(item),
            columnClassName: columnClassName
          });
        })
      });
    },
    ...props
  } = _ref;
  function getItemKey(item) {
    return typeof item.value === 'boolean' ? `${item.value}` : item.value;
  }
  return /*#__PURE__*/_jsx(BoxSelector, {
    ...props,
    children: renderItems?.({
      options,
      getItemKey,
      columnClassName
    })
  });
}
export function BoxSelectItem(_ref3) {
  let {
    label,
    value,
    className,
    columnClassName,
    disabled
  } = _ref3;
  return /*#__PURE__*/_jsx(BoxColumn, {
    className: cx(columnClassName, {
      'is-disabled': disabled
    }),
    children: /*#__PURE__*/_jsx(BoxItem, {
      value: value,
      className: className,
      children: label
    })
  });
}